<template>
    <div class="rn-new-items rn-section-gapTop">
        <div class="container">
            <div class="row mb--50 align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <h3 class="title mb--0" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                        INFO
                    </h3>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt_mobile--15">
                    <div class="view-more-btn text-start text-sm-end">
                        <router-link to="'/blog-col-three'"  class="btn-transparent" data-sal-delay="150" data-sal="slide-up" data-sal-duration="800">
                          VIEW ALL <i class="feather-arrow-right"/></router-link> 
                     
                    </div>
                </div>
            </div>
            <div class="row g-5">
                <div class="col-5 col-lg-4 col-md-6 col-sm-6 col-12"
                     v-for="(item, index) in newestItemList"
                     :key="`newest-item-${index}`"
                     data-sal="slide-up"
                     :data-sal-delay="150+index"
                     data-sal-duration="800">
                    <product-card
                        :product-date="item"
                        product-style-class="no-overlay"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductCard from '@/components/product/ProductCard1'

    export default {
        name: 'ExploreNewestItem',
        components: {ProductCard},
        data() {
            return {
                newestItemList: [
                    {
                        id: 1,
                        productImage: require(`@/assets/images/portfolio/portfolio-01.jpg`),
                        authors: [
                            {
                                id: 1,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-1.png`)
                            },
                            {
                                id: 2,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-2.png`)
                            },
                            {
                                id: 3,
                                name: 'Nisat Tara',
                                image: require(`@/assets/images/client/client-3.png`)
                            }
                        ],
                        biddingAmount: '20',
                        productName: 'Wireless headset',
                        latestBid: 'High fidelity cordless WIFI earphones',
                        collect: '20',
                        info:"89",
                        reacted: '322'
                    },
                    {
                        id: 2,
                        productImage: require(`@/assets/images/portfolio/portfolio-02.jpg`),
                        authors: [
                            {
                                id: 4,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-4.png`)
                            },
                            {
                                id: 5,
                                name: 'Nira Ara',
                                image: require(`@/assets/images/client/client-5.png`)
                            },
                            {
                                id: 6,
                                name: 'Fatima Afrafy',
                                image: require(`@/assets/images/client/client-6.png`)
                            }
                        ],
                        biddingAmount: '10',
                        productName: 'UAV',
                        latestBid: 'High tech intelligent wireless drone',
                        collect: '5',
                        info:"99",
                        reacted: '420'
                    },
                    {
                        id: 3,
                        productImage: require(`@/assets/images/portfolio/portfolio-03.jpg`),
                        authors: [
                            {
                                id: 1,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-1.png`)
                            },
                            {
                                id: 8,
                                name: 'Janin Ara',
                                image: require(`@/assets/images/client/client-8.png`)
                            },
                            {
                                id: 9,
                                name: 'Atif Islam',
                                image: require(`@/assets/images/client/client-9.png`)
                            }
                        ],
                        biddingAmount: '10',
                        productName: 'Balanced vehicle',
                        latestBid: 'Mijia Nine Balance Car Deluxe Limited Edition',
                        collect: '99',
                        info:"45",
                        reacted: '12'
                    },
                    {
                        id: 4,
                        productImage: require(`@/assets/images/portfolio/portfolio-04.jpg`),
                        authors: [
                            {
                                id: 1,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-1.png`)
                            },
                            {
                                id: 3,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-3.png`)
                            },
                            {
                                id: 5,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-5.png`)
                            }
                        ],
                        biddingAmount: '8',
                        productName: 'projector',
                        latestBid: 'Mijia Wireless Projector Youth Edition',
                        collect: '34',
                        info:"1",
                        reacted: '20'
                    },
                    {
                        id: 5,
                        productImage: require(`@/assets/images/portfolio/portfolio-05.jpg`),
                        authors: [
                            {
                                id: 2,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-2.png`)
                            },
                            {
                                id: 7,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-7.png`)
                            },
                            {
                                id: 9,
                                name: 'Jone lee',
                                image: require(`@/assets/images/client/client-9.png`)
                            }
                        ],
                        biddingAmount: '15',
                        productName: 'camera',
                        latestBid: 'GoPro Hero4 Silver hd camera',
                        collect: '55',
                        info:"10",
                        reacted: '205'
                    }
                ]
            }
        },
        mounted() {
           this.getMetadata()
        },
        methods:{
            getMetadata() {
            fetch('https://apph5.matrixpower.club/addons/cms/api.archives/index?&channel=-1&model=-1&page=1', {
                method: 'GET', // 默认就是GET，可省略
                headers: {
                    'Content-Type': 'application/json', // 声明数据格式
                    'Authorization': 'Bearer xxxxxxxx' // 身份令牌（如登录后获取）
                }
            })
                .then(response => {
                    if (!response.ok) throw new Error('请求失败');
                    return response.json(); // 解析JSON格式的响应数据
                })
                .then(data => {
                    this.newestItemList = data.data.pageList.data
                    // this.total = data.data.pageList.total

                    console.log('接口返回数据：', this.newestItemList); // 处理数据（如渲染到页面）
                })
                .catch(error => {
                    console.error('错误：', error); // 处理错误（如网络异常、权限不足）
                });
        },
        }
    }
</script>